import React from "react";
import { useState, useRef, useEffect } from "react";

const VendorTabs = ({
  approvalCounts,
  handleSearchChangeHead,
  setActive,
  active,
}) => {
  const tabs = [
    {
      id: "Approved",
      label: "Approved",
      count: approvalCounts.approved,
      status: "1",
    },
    {
      id: "Pending",
      label: "Pending",
      count: approvalCounts.pending,
      status: "0",
    },
    {
      id: "Rejected",
      label: "Rejected",
      count: approvalCounts.rejected,
      status: "-1",
    },
    {
      id: "Blacklisted",
      label: "Blacklisted",
      count: approvalCounts.blacklisted,
      status: "-2",
    },
  ];
  const userRole = localStorage.getItem("role");

  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });
  const tabRefs = useRef({});
  const containerRef = useRef(null);

  useEffect(() => {
    const el = tabRefs.current[active];
    if (el && containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const tabRect = el.getBoundingClientRect();
      setIndicatorStyle({
        left: tabRect.left - containerRect.left,
        width: tabRect.width,
      });
    }
  }, [active]);

  return (
    <div className="">
      {/* Tab Bar */}
      <div
        ref={containerRef}
        role="tablist"
        className="
          relative inline-flex items-center gap-0.5
          bg-white rounded-xl  py-1.5
          shadow-sm 
          overflow-x-auto scrollbar-none 
        "
      >
        {/* Animated sliding background */}
        <span
          aria-hidden
          className="absolute top-1.5 bottom-1.5 rounded-lg bg-gray-100 transition-all duration-200 ease-in-out pointer-events-none z-0"
          style={indicatorStyle}
        />

        {tabs.map((tab) => {
          const isActive = active === tab.id;
          return (
            <button
              key={tab.id}
              ref={(el) => (tabRefs.current[tab.id] = el)}
              role="tab"
              aria-selected={isActive}
              onClick={() => {
                setActive(tab.id);
                handleSearchChangeHead(tab.status, "adminApproval");
              }}
              className={`
                relative z-10 flex items-center gap-1.5
                px-3 py-1.5 rounded-lg whitespace-nowrap
                text-[13px] font-medium tracking-tight
                transition-colors duration-150 cursor-pointer
                ${isActive ? "text-gray-900 font-semibold" : "text-gray-400 hover:text-gray-600"}
              `}
            >
              {tab.label}
              <span
                className={`
                  inline-flex items-center justify-center
                  text-[11px] font-semibold rounded-md px-1.5 py-px min-w-[22px]
                  transition-colors duration-150
                  ${
                    isActive
                      ? "bg-gray-900 text-white"
                      : "bg-gray-100 text-gray-500"
                  }
                `}
              >
                {tab.count}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default VendorTabs;
